import { ClaimFileDto } from "../features/claims/types";
import { getDocumentContentType } from "../components/DocumentsPanels/documentUtils";

export const getClaimFileContentType = (fileDto: ClaimFileDto) => getDocumentContentType(fileDto);

export const mergeFiles = (current: ClaimFileDto[], incoming: ClaimFileDto[]) => {
    const next = [...current];
    incoming.forEach((file) => {
        const idx = next.findIndex((item) =>
            item.id != null && file.id != null ? item.id === file.id : item.fileName === file.fileName
        );
        if (idx >= 0) next[idx] = { ...next[idx], ...file };
        else next.push(file);
    });
    return next;
};